<template>
  <div class="app flex-row mt-3 animated fadeIn">
    <div class="container">
      <b-row class="justify-content-center">
        <div :class="$config.auth.registerIsEnabled ? 'col-lg-9' : 'col-xl-4 col-lg-5 col-md-6'">
          <!-- <b-img class="d-block mx-auto mb-3" src="/img/logo-full.png" fluid :alt="$t('shared.AppLogo')" /> -->

          <b-alert :show="errors.any()" variant="danger" class="px-4">
            <ul class="m-0 px-1">
              <li v-for="err in errors.all()" :key="err">{{ err }}</li>
            </ul>
          </b-alert>

          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">
                <b-form @submit.prevent="submit">
                  <h5 class="text-center font-weight-bold">
                    Business Client Log in
                  </h5>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend is-text>
                      <font-awesome-icon icon="user" />
                    </b-input-group-prepend>
                    <b-input
                      v-model="model.Email"
                      dir="auto"
                      v-validate="'required|email'"
                      name="Username"
                      placeholder="Username (Email Address)"
                    ></b-input>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend is-text>
                      <font-awesome-icon icon="key" />
                    </b-input-group-prepend>
                    <b-input
                      type="password"
                      v-model="model.Password"
                      dir="auto"
                      v-validate="'required'"
                      name="Password"
                      placeholder="Password"
                    ></b-input>
                  </b-input-group>
                  <button type="submit" :disabled="progressing" class="btn btn-warning btn-block px-4">
                    Log in
                  </button>
                  <b-btn to="/forget-password" variant="link" block class="mt-3">Forgot your password?</b-btn>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types'

export default {
  name: 'login',
  data() {
    return {
      model: {
        Email: null,
        Password: null,
        RememberMe: true
      },
      progressing: false,

      showPwaButton: false,
      installPromptEvent: null
    }
  },
  computed: {
    usernameLabel() {
      let label = this.$t('account.Username')
      if (this.$config.auth.loginByEmail) {
        label = this.$t('account.Email')
      } else if (this.$config.auth.loginByMobile) {
        label = this.$t('shared.Mobile')
      }
      return label
    }
  },
  mounted() {
    if (this.$cookies.get('aacc')) {
      this.$router.push('/dashboard')
    }
    // window.chaport.on('ready', function () {
    //   console.log("called from loggin")
    //   window.chaport.stopSession(); 

    // });
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.progressing = true
          this.$api.account
            .login(this.model, true)
            .then(user => {
              
              this.progressing = false
              this.setAccount(user)

              localStorage.setItem("requirePin", false)
            })
            .catch(err => {
              // this.$showError(this.$getLocaleErrorMessage(err, 'account'))
              // this.progressing = false
              // return false
              this.progressing = false
              if (err.response.data) {
                this.$showError(err.response.data.message)
              } else {
                this.$showError('error was occured')
              }
            })
        }
      })
    },
    setAccount(user) {
      this.$store.commit(types.SET_ACCOUNT, user)
      // let go = this.$route.query.go || this.$config.homeUrl
      this.$router.replace('/dashboard')
    }
  }
}
</script>
